import { render, staticRenderFns } from "./ApplicationDetails.vue?vue&type=template&id=bf6b41a6&scoped=true&"
import script from "./ApplicationDetails.vue?vue&type=script&lang=js&"
export * from "./ApplicationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6b41a6",
  null
  
)

export default component.exports